import { rarityVariables } from '../theme/cssVariables'

export enum shortExteriorEnum {
  De,
  BS,
  WW,
  FT,
  MW,
  FN,
}

export type exteriorType = 0 | 1 | 2 | 3 | 4 | 5
export type rarityType =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
export type phaseType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7
export type specialtyType = 2 | 3 | 4

// 颜色映射（基于 rarity 键而不是翻译值）
export const getRarityColorMap = (rarityKey: rarityType) => {
  const colorMaps = {
    0: {
      border: rarityVariables['--rarity-consumer-border'],
      background: rarityVariables['--rarity-consumer-bg'],
    },
    1: {
      border: rarityVariables['--rarity-consumer-border'],
      background: rarityVariables['--rarity-consumer-bg'],
    },
    2: {
      border: rarityVariables['--rarity-industrial-border'],
      background: rarityVariables['--rarity-industrial-bg'],
    },
    3: {
      border: rarityVariables['--rarity-mil-spec-border'],
      background: rarityVariables['--rarity-mil-spec-bg'],
    },
    4: {
      border: rarityVariables['--rarity-restricted-border'],
      background: rarityVariables['--rarity-restricted-bg'],
    },
    5: {
      border: rarityVariables['--rarity-classified-border'],
      background: rarityVariables['--rarity-classified-bg'],
    },
    6: {
      border: rarityVariables['--rarity-covert-border'],
      background: rarityVariables['--rarity-covert-bg'],
    },
    7: {
      border: rarityVariables['--rarity-rare-border'],
      background: rarityVariables['--rarity-rare-bg'],
    },
    8: {
      border: rarityVariables['--rarity-extraordinary-border'],
      background: rarityVariables['--rarity-extraordinary-bg'],
    },
    9: {
      border: rarityVariables['--rarity-contraband-border'],
      background: rarityVariables['--rarity-contraband-bg'],
    },
    10: {
      border: rarityVariables['--rarity-contraband-border'],
      background: rarityVariables['--rarity-contraband-bg'],
    },
    11: {
      border: rarityVariables['--rarity-contraband-border'],
      background: rarityVariables['--rarity-contraband-bg'],
    },
    12: {
      border: rarityVariables['--rarity-contraband-border'],
      background: rarityVariables['--rarity-contraband-bg'],
    },
    13: {
      border: rarityVariables['--rarity-contraband-border'],
      background: rarityVariables['--rarity-contraband-bg'],
    },
    14: {
      border: rarityVariables['--rarity-consumer-border'],
      background: rarityVariables['--rarity-consumer-bg'],
    },
    15: {
      border: rarityVariables['--rarity-contraband-border'],
      background: rarityVariables['--rarity-contraband-bg'],
    },
    16: {
      border: rarityVariables['--rarity-contraband-border'],
      background: rarityVariables['--rarity-contraband-bg'],
    },
    17: {
      border: rarityVariables['--rarity-contraband-border'],
      background: rarityVariables['--rarity-contraband-bg'],
    },
    18: {
      border: rarityVariables['--rarity-contraband-border'],
      background: rarityVariables['--rarity-contraband-bg'],
    },
  }

  return colorMaps[rarityKey] || colorMaps[0]
}

export const SkinProperties = {
  exterior: {
    0: 'Default',
    1: 'Battle-Scarred',
    2: 'Well-Worn',
    3: 'Field-Tested',
    4: 'Minimal Wear',
    5: 'Factory New',
  },
  phase: {
    0: 'Phase 1',
    1: 'Phase 2',
    2: 'Phase 3',
    3: 'Phase 4',
    4: 'Ruby',
    5: 'Sapphire',
    6: 'Black Pearl',
    7: 'Emerald',
  },
  specialty: {
    2: 'StatTrak™',
    3: '★',
    4: '★ StatTrak™',
  },
}
